import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SolutionsDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoverIndex, setHoverIndex] = useState(null);

  const sections = [
    { title: "Vehicle Engineering", slug: "vehicle-engineering", bg: " #AFD7E9" },
    { title: "Sales & Marketing", slug: "sales-and-marketing", bg: "#F6B483" },
    { title: "After Sales & Customer Service", slug: "after-sales-and-customer-service", bg: "#9DDCD2" },
    { title: "Fleet Management", slug: "fleet-management", bg: "#B0C5F9" },
    { title: "Quality", slug: "quality", bg: "#F7C5D9" },
    { title: "Regulatory & Sustainability", slug: "regulatory-and-sustainability", bg: "#B0E0A4" }
  ];

  const defaultBg = "#ECEAEB";
  const currentSolutionName = decodeURIComponent(
    location.pathname.replace("/solution/", "")
  );
  const isMobile = window.innerWidth < 1024;

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "1.5rem",
        boxShadow: "0px 4px 4px 0px rgba(249, 245, 245, 0.25)",
        zIndex: "9999",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
          gap: isMobile ? "0" : "1rem",
        }}
      >
        {sections.map((item, idx) => {
          const isActive = currentSolutionName === item.slug;
          const isHovered = hoverIndex === idx;
          const bgColor = isHovered ? "#D2D2D2" : isActive ? item.bg : defaultBg;

          return (
            <div
              key={idx}
              style={{
                backgroundColor: isMobile ? "none" : bgColor,
                padding: "16px",
                borderRadius: isMobile ? "0" : "6px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                // height: "72px",
                height: window.innerWidth < 1024 ? "80px" : "72px",
                boxShadow: !isMobile && (isHovered || isActive ? "0 4px 12px rgba(0,0,0,0.12)" : "none"),
                borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
              }}
              onClick={() =>
                navigate(`/solution/${item.slug}`)
              }
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: isMobile ? "34px" : "18px",
                  color: isMobile && isActive ? "#F00D69" : "#111827",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    flex: 1,
                  }}
                >
                  {item.title}
                </span>
                <img
                  src="/assets/fonts/icons/RightIcon.png"
                  alt="arrow"
                  style={{
                    width: "6px",
                    height: "8px",
                    marginLeft: "10px",
                    flexShrink: 0,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SolutionsDropdown;
